export function isAuthError(error) {
    let authError;
    try {
        authError = error.response.data.errors[0].extensions.extensions.http.status === 401;
    } catch (error) {
        authError = false;
    }
    return authError;
}